import React, {useEffect, useState} from "react";
import {Box, Typography} from "@mui/material";

import facebook from "../../../assets/images/facebook.svg";
import telegram from "../../../assets/images/telegram.svg";
import twitter from "../../../assets/images/twitter.svg";
import discord from "../../../assets/images/discord.svg";
import instagram from "../../../assets/images/instagram.svg";
import whatsapp from "../../../assets/images/whatsapp.svg";
import {useVarAuth} from "../../../graphql/graphql/auth/defaults";

const socialIcons = [
  {icon: facebook, href: "facebook.com/share?text"},
  {icon: telegram, href: "telegram.me/share/url?url"},
  {icon: twitter, href: "twitter.com/share?text"},
  {icon: discord, href: "discord.com/share?&text"},
  {icon: instagram, href: "api.instagram.com/send?&text"},
  {icon: whatsapp, href: "api.whatsapp.com/send?&text"},
];

const ShareLinks = ({type}) => {
  const {user} = useVarAuth();
  const [referralShareContent, setReferralShareContent] = useState("");

  useEffect(() => {
    setReferralShareContent(
      `Hey. Come trade with us at buythedip.com. Use my link for 20% off: https://buythedip.com/?referrer=${user.referralCode}.`
    );
  }, []);

  return type == "vertical" ? (
    <>
      <Typography variant="h5" mb={2}>
        Share now
      </Typography>
      <Box className="shareIcons" display="flex" alignItems="center" flexWrap="wrap">
        {socialIcons.map((social, key) => (
          <a target={"_blank"} href={`https://${social.href}=${encodeURIComponent(referralShareContent)}`} key={key}>
            <img src={social.icon} alt="icon" />
          </a>
        ))}
      </Box>
    </>
  ) : (
    <Box className="shareLink" display="flex" alignItems="flex-start" mt={1}>
      <Typography>Share:</Typography>
      {socialIcons.map((social, key) => (
        <a target={"_blank"} href={`https://${social.href}=${encodeURIComponent(referralShareContent)}`} key={key}>
          <img src={social.icon} alt="icon" />
        </a>
      ))}
    </Box>
  );
};

export default ShareLinks;
